import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';
import './editor.scss';

const ALLOWED_BLOCKS = ['asl/advanced-button'];

export default function Edit() {
	const blockProps = useBlockProps({
		className: 'advanced-buttons',
	});

	const innerBlocksProps = useInnerBlocksProps(blockProps, {
		allowedBlocks: ALLOWED_BLOCKS,
		template: [['asl/advanced-button']],
		templateInsertUpdatesSelection: true,
	});

	return <div {...innerBlocksProps} />;
}
